<h2 mat-dialog-title>Atenção</h2>
<mat-dialog-content>
  <p [innerHTML]="data.message"></p>
</mat-dialog-content>
<mat-dialog-actions class="button-dialog">
  <button matButton="filled" mat-dialog-close>OK</button>
</mat-dialog-actions>
